import ChildContractTypeEnum from '../../../contants/ChildContractType';
import Action7 from '../Action7';
import LostAction from '../LostAction';

interface IProp {
  proposal: any;
  statusActual: any;
}
const Action4 = ({ proposal, statusActual }: IProp) => {
  if (proposal.childContractType == ChildContractTypeEnum.Bowe) {
    return (<>
      <button className='btn btn-primary ms-auto btnForm minWidth200'
        onClick={() => { window.location.href = `/ProposalActionBowe/${proposal.id}` }}
        >Aceite</button>
      <LostAction proposal={proposal} />
    </>
    )
  } else {
    return <Action7 proposal={proposal} statusActual={statusActual} />;
  }

};

export default Action4;
